import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    boxSizing: 'border-box',
    width: '100%',
    // Let the row parent’s `align-items: stretch` set height. `height: 100%` here is
    // non-auto and often fails to resolve against a flex line, so the box stays content-tall
    // and only `min-height: 60vh` applies (~600px on a 1kpx viewport).
    alignSelf: 'stretch',
    minHeight: '60vh',
    gap: theme.spacing(3),
  },
  /** Submission confirmation: header + callout grow; actions sit at bottom. */
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    minHeight: 0,
  },
  submissionActions: {
    marginTop: 'auto',
    flexShrink: 0,
    width: '100%',
  },
}));
